import React, { Component, Fragment, useState, useEffect, useRef } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { Link, useNavigate } from "react-router-dom";


import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";

import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useCustomizeContext } from "../../context/index";
import { Notify } from "notiflix";
import { NumericFormat } from 'react-number-format';
import axios from 'axios';


import { useTranslation, I18nextProvider } from "react-i18next";
import { getUserDetails } from "../../Features/SiteSettings/siteSettingSlice";
import { currencyreq } from "../../Features/WalletDetails/walletBalanceSlice";
import { useSelector } from "react-redux";

import { reverifymail } from "../../Features/LinkEmail/linkEmailSlice";

import { PatternFormat } from "react-number-format";
// reverifymail

import {
   getUserbank,
   addDepositreq,
   getAdminbankdetails,
   addWithdrawreq,

} from "../../Features/Bankdetails/bankDetailsSlice";
import { number } from "yup";

import { checkWithdrawStatus } from "../../Features/Transaction/transactionSlice";
// import https from 'https';
// import * as https from "https";





const Withdraw = (props) => {
   const { t, i18n } = useTranslation();
   const amountRef = useRef();
   // const https = require('https')



   const {
      loader: { loading, setLoading },
      bet: { selectedCurrency, setSelectedCurrency, balance, setBalance, selectCurrency, setSelectCurrency, brlbal, setBrlbal },


      sideMenu: {
         classIsActive, setClassIsActive
      },
   } = useCustomizeContext();

   let navigate = useNavigate()







   const kycdata = useSelector((state) => state?.siteSettings?.userDetails?.data?.details);

   const [payment, setPayment] = useState("bank");
   const [uploadimg, setUploadimg] = useState();
   const [bankdata, setBankdata] = useState({});
   const [tfastatus, setTfastatus] = useState();
   const [kycstatus, setKycstatus] = useState();
   const [currencydata, setCurrencydata] = useState();


   let dispatch = useDispatch();

   const [bankname, setBankname] = useState([]);


   const [withdrawAmount, setWithdrawAmount] = useState();
   const {
      register,
      reset,
      handleSubmit,
      watch,
      formState: { errors },
   } = useForm();

   useEffect(() => {
      banklist();
      userHomepage();
      currencylist();

   }, []);


   const [checkWithdrawRes, setCheckWithdrawRes] = useState();

   const [isWithdraw, setIsWithdraw] = useState(false);



   useEffect(() => {
      document.body.classList.remove("SideMenuOpen");
      setClassIsActive(false);
   }, []);

   useEffect(() => {
      checkStatus();
   }, [checkWithdrawRes]);


   const checkStatus = async () => {
      let res = await dispatch(checkWithdrawStatus());
      setIsWithdraw(res?.status);
   }


   const currencylist = async () => {
      let res = await dispatch(currencyreq({ "currency_symbol": "R$" }));
      if (res?.status) {
         setCurrencydata(res?.data);
      }
   };


   const banklist = async () => {
      let res = await dispatch(getUserbank());
      if (res?.status) {
         setBankname(res?.data);
         setBankdata((data) => ({
            ...data,
            acc_num: res?.data[0]?.account_no,
            ifsc_num: res?.data[0]?.ifsc_code,
            bank_name: res?.data[0]?.bank_name,
         }));
      }
   };

   const userHomepage = async () => {
      setLoading(true);
      let res = await dispatch(getUserDetails());

      setTimeout(() => {
         if (res?.status) {
            setKycstatus(res?.data?.details?.kycfinal_status)
            setTfastatus(res?.data?.details?.randcode)
            setLoading(false);
         }
         else {
            setLoading(false);
         }
      }, 1000);
   }

   // verified

   const onSubmit = async (data, e) => {
      e.preventDefault();

      if (kycdata?.verified) {

         if (!withdrawAmount) {
            amountRef.current.focus()
         }


         else if (Number(withdrawAmount) > Number(brlbal)) {

            Notify.failure(`${t("Insufficient wallet balance")}`, {
               showOnlyTheLastOne: true,
               clickToClose: true,
               timeout: 1500,
            });
         }

         else if (withdrawAmount < currencydata?.min_withdraw) {

            Notify.failure(`${t("Withdraw amount must be greater than minimum withdraw amount")}`, {
               showOnlyTheLastOne: true,
               clickToClose: true,
               timeout: 1500,
            });


         }

         else if (selectCurrency?.name !== "BRL") {

            Notify.failure(`${t("Withdraw process can't be done by Test token")}`, {
               showOnlyTheLastOne: true,
               clickToClose: true,
               timeout: 1500,
            });


         }



         else if (withdrawAmount >= 99) {
            setLoading(true);
            let withdrawdata = {
               "paymentmode": "pix",
               "currency_name": "BRL",
               "pixkey": kycdata?.CPF?.includes('-') ? kycdata?.CPF?.replaceAll('.', '').replaceAll('-', '') : kycdata?.CPF,
               "reqamount": withdrawAmount,
            }
            let res = await dispatch(addWithdrawreq(withdrawdata));
            if (res?.status) {
               setLoading(false);
               setCheckWithdrawRes(res);
            }
            else {
               setLoading(false);
            }
         }


         else {
            setLoading(true);


            const options = {
               method: 'POST',
               url: 'https://api.cassino.vibescash.com/v1/transfers',
               headers: { accept: 'application/json', 'content-type': 'application/json', authorization: 'Basic c2tfbGl2ZV9mWGVaaGJBSVVmRWIyZ3NXM0JET0E5Z3c0R1pvWFI6eA==' },
               data: {
                  amount: currencydata?.fee_type == 1 ? Number(withdrawAmount) -
                     Number(currencydata?.fee) : Number(
                        withdrawAmount -
                        withdrawAmount *
                        (currencydata?.fee / 100)
                     ) * 100, postbackUrl: "https://apiricojogos.osiztech.com/user/approveorrejectwithdraw", pixKey: kycdata?.CPF?.includes('-') ? kycdata?.CPF?.replaceAll('.', '').replaceAll('-', '') : kycdata?.CPF, externalRef: null
               }
            };

            await axios
               .request(options)
               .then(async function (response) {

                  if (response?.data?.status) {


                     let withdrawdata = {
                        "paymentmode": "pix",
                        "currency_name": "BRL",
                        "pixkey": response?.data?.pixKey,
                        "reqamount": Number(withdrawAmount),
                        "id": response?.data?.id

                     }
                     await createpayment(withdrawdata)
                  }
                  else {

                     setWithdrawAmount()

                     setLoading(false)

                  }
               })
               .catch(function (error) {
                  Notify.failure(`${t("We were unable to process your request at this time, please try again later.")}`, {
                     showOnlyTheLastOne: true,
                     clickToClose: true,
                     timeout: 1500,
                  });

                  // Notify.failure(error?.response?.data?.message, {
                  //    showOnlyTheLastOne: true,
                  //    clickToClose: true,
                  //    timeout: 1500,
                  // });
                  setLoading(false)
                  setWithdrawAmount()

                  console.error(error);
               });

           
         }
      }
      else {

         // alert("checkk")

         await mailverify();
         // console.log("checkk")
      }
   }


   const mailverify = async () => {

      let res = await dispatch(reverifymail());
      console.log('res: ', res);


   }


   const createpayment = async (data) => {
      let res = await dispatch(addWithdrawreq(data));
      if (res?.status) {
         setWithdrawAmount()
         setCheckWithdrawRes(res);
         setLoading(false)
      }
      else {
         setWithdrawAmount()
         setLoading(false)

      }
   };

   // const check = () => {


   //    const options = {
   //       method: 'POST',

   //       url: "https://api.cassino.vibescash.com/v1"
   //       // url: 'https://api.pay.vibescash.com.br/v1/transfers',
   //       headers: { accept: 'application/json', 'content-type': 'application/json' },
   //       data: { amount: 0, postbackUrl: 'string', pixKey: 'string', externalRef: 'string' }
   //    };

   //    axios
   //       .request(options)
   //       .then(function (response) {
   //          console.log(response.data);
   //       })
   //       .catch(function (error) {
   //          console.error(error);
   //       });
   // }

   // useEffect(() => {
   //    check()

   // }, []);

   return (
      <Fragment>
         <Header />
         <div class="mainbody-content">
            <Sidebar />
            <div class="center-maincnt">
               <div class="inr-container">
                  <div class="center-inrcnt">
                     <div className="withdrawpage-main">
                        <div className="withdrawpage-maincnt">
                           <div class="withdrawpage-maincnt">
                              <h5 class="page-head">{t("Withdraw")}</h5>
                              <div class="withdraw-form">
                                 <form onSubmit={handleSubmit(onSubmit)}>
                                    <div class="row">
                                       <div class="col-sm-6">
                                          <div class="form-group">
                                             <label>{t("Payment Method")}</label>
                                             <input
                                                type="text"
                                                class="form-control"
                                                value="PIX"
                                             />
                                          </div>
                                       </div>
                                       <div class="col-sm-6">
                                          <div class="form-group">
                                             <label>CPF Number</label>
                                             <PatternFormat
                                                className="form-control"
                                                allowLeadingZeros
                                                format="###.###.###-##"
                                                value={kycdata?.CPF?.includes('-') ? kycdata?.CPF?.replaceAll('.', '').replaceAll('-', '') : kycdata?.CPF}
                                                disabled={true}
                                             />
                                          </div>
                                       </div>


                                       <div class="col-sm-6">
                                          <div class="form-group">
                                             <label>{t("Enter Your Amount")}</label>
                                             <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                   <span class="input-group-text text-white" id="basic-addon1">R$</span>
                                                </div>
                                                <NumericFormat class="form-control" getInputRef={amountRef} placeholder={`${t('Enter Your Amount')}`} allowNegative={false} value={withdrawAmount} onChange={(e) => setWithdrawAmount(e.target.value)} />
                                             </div>
                                          </div>
                                       </div>



                                       <div class="tot-amount flex-wrap">
                                          <p>{t("Fee")}: {currencydata?.fee_type == 1
                                             ? currencydata?.fee
                                             : `${currencydata?.fee}%`}{" "}</p>
                                          <p>{t("Receiving Amount")} : {currencydata?.fee_type == 1
                                             ? withdrawAmount
                                                ? Number(withdrawAmount) -
                                                Number(currencydata?.fee)
                                                : "0"
                                             : withdrawAmount
                                                ? Number(
                                                   withdrawAmount -
                                                   withdrawAmount *
                                                   (currencydata?.fee / 100)
                                                )
                                                : "0"} BRL</p>

                                          <p>{t("Min Withdraw")}: {currencydata?.min_withdraw} BRL</p>

                                       </div>

                                       <div class="tot-amount" style={{ color: "#93a1c0" }}>

                                          {t("Note")} : {t("withdraw can able to do one time per every 24 hours")}
                                          {/* <p>{t("Min Withdraw")}: {currencydata?.min_withdraw} BRL</p> */}
                                          {/* <p>{t("Max Withdraw")}: {currencydata?.max_withdraw} BRL</p> */}

                                       </div>
                                    </div>

                                    {
                                       kycdata?.kycfinal_status ? (

                                          <div>
                                             <button class="btn btn-primary submit-btn" style={{ cursor: isWithdraw === false ? 'pointer' : 'not-allowed' }} disabled={isWithdraw === false ? false : true} type="submit">{kycdata?.verified ? t("Submit") : t("Complete your Email verify")}</button>
                                          </div>

                                       ) : (

                                          <button class="btn btn-primary submit-btn" style={{ "width": "150px" }} onClick={() => navigate("/kyc")}>{t('Complete Your KYC')}</button>

                                       )
                                    }
                                 </form>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <Footer />
               </div>
            </div>
         </div>
      </Fragment>
   );

}

export default Withdraw;



